import AlertMsg from "./alertMsg.js";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import styles from "./styles.js";

export default withStyles(styles)(withRouter(AlertMsg));
